import React, { useState, useEffect } from "react";
import "./PreHero.scss";
import { useNavigate } from "react-router-dom";
export const getImageSrc = (item) => {
  if (!item) return "";

  return (
    item.prev || item.preview || item.image || item.logo || item.thumbnail || ""
  );
};

const PreHeroSlider = ({ data }) => {
  const [current, setCurrent] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const slides = data.slice(0, 5);

  useEffect(() => {
    if (isHovered || slides.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isHovered, slides.length]);

  if (slides.length === 0) return null;

  const slide = slides[current];
  const imageSrc = getImageSrc(slide);

  return (
    <section className="palestina">
      <div className="palestina__container">
        <div className="palestina__content">
          <h1 className="palestina__title">
            {slide.name}

            {slide.name && <span> Restoration Project</span>}
          </h1>

          <div className="palestina__tags">
            <span>{slide.count || 0} Items</span>
            <span>ETH</span>
          </div>

          <p className="palestina__desc">{slide.description}</p>

          <button
            className="palestina__btn"
            onClick={() =>
              navigate(
                `/reproduction/collections?country=${slide.name}&collection=${slide.id}`,
                {
                  state: {
                    country: slide.name,
                    collectionId: slide.id,
                  },
                },
              )
            }
          >
            View Collection
          </button>
        </div>

        <div
          className="palestina__image"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ backgroundImage: imageSrc ? `url(${imageSrc})` : "none" }}
        >
          <div className="slider-lines">
            {slides.map((_, index) => (
              <div
                key={index}
                className="line"
                onClick={() => setCurrent(index)}
              >
                <span className="bar"></span>
                {current === index && <span className="pre-dot"></span>}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="palestina__tabs">
        <span
          onClick={() => {
            document
              .getElementById("WorldChronicles")
              .scrollIntoView({ behavior: "smooth" });
          }}
        >
          World Chronicles
        </span>

        <span
          onClick={() => {
            document
              .getElementById("CulturalHeritage")
              .scrollIntoView({ behavior: "smooth" });
          }}
        >
          Cultural Heritage
        </span>
      </div>
    </section>
  );
};

const PreHeroSimple = ({ image, className = "", children }) => {
  return (
    <section className={`PreHero ${className}`.trim()}>
      <div className="PreHero-background">
        <div
          className="PreHero-image"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
        <div className="PreHero-gradient" />
      </div>
      {children && <div className="PreHero-overlay">{children}</div>}
    </section>
  );
};

const PreHero = ({ data, image, className, children }) => {
  if (data) {
    return <PreHeroSlider data={data} />;
  }
  return (
    <PreHeroSimple image={image} className={className}>
      {children}
    </PreHeroSimple>
  );
};

export default PreHero;
